import type { Canvas } from "../../Canvas.ts";
import { type Drawable, MAX_SIZE, type Position, type Size, ZERO_SIZE } from "../../Drawable.ts";
import { drawBorderAsset } from "./MetalBeveledBorder.ts";

export const stoneCardFrameAsset = "/images/assets/card-frame/stone/stone-card-frame.png";
export const stoneIconPanelOctagonAsset =
	"/images/assets/card-frame/stone/stone-icon-panel-octagon.png";
export const stoneEdgePanelHorizontalAsset =
	"/images/assets/card-frame/stone/stone-edge-panel-horizontal.png";
export const darkSlateTextureAsset = "/images/assets/card-frame/stone/dark-slate-texture.png";

export const STONE_CARD_ASSETS = [
	stoneCardFrameAsset,
	stoneIconPanelOctagonAsset,
	stoneEdgePanelHorizontalAsset,
	darkSlateTextureAsset,
] as const;

export class StoneCardFrame implements Drawable {
	public draw(document: Canvas, position: Position, size: Readonly<Size>): void {
		drawBorderAsset(document, stoneCardFrameAsset, position.x, position.y, size.width, size.height);
	}

	public minSize(): Size {
		return ZERO_SIZE;
	}

	public maxSize(): Size {
		return MAX_SIZE;
	}

	public widthToHeightRatio(): number {
		return 1;
	}
}
